import { cn } from "@/lib/utils";

/** Shared app chrome — neutral surface in light mode, dark glass in dark mode. */
export const appNavShellClass =
  "sticky top-0 z-50 shadow-sm border-b bg-background/95 backdrop-blur-xl border-border text-foreground dark:bg-black/60 dark:border-white/10 dark:text-white";

export const appMobileHeaderClass =
  "md:hidden p-3 flex items-center gap-3 sticky top-0 z-50 shadow-sm bg-background/95 backdrop-blur-xl border-b border-border text-foreground dark:bg-soccer-primary-dark dark:text-white dark:border-transparent";

export const appBottomNavClass =
  "md:hidden fixed bottom-0 left-0 right-0 z-50 animate-slide-in-up border-t shadow-2xl backdrop-blur-xl rounded-t-2xl pb-[env(safe-area-inset-bottom)] bg-background/95 border-border text-foreground dark:bg-black/60 dark:border-white/10 dark:text-white";

export function appNavLinkClass(active: boolean, className?: string) {
  return cn(
    "px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-all duration-300 relative",
    active
      ? "bg-soccer-primary/12 text-soccer-primary-800 border border-soccer-primary/30 font-semibold dark:bg-white/20 dark:text-white dark:border-white/30 dark:shadow-md"
      : "text-muted-foreground hover:bg-muted hover:text-foreground dark:text-white/90 dark:hover:bg-white/10 dark:hover:text-white",
    className
  );
}

export function appBottomNavLinkClass(active: boolean, className?: string) {
  return cn(
    "flex flex-col items-center justify-center px-1 py-1 relative group transition-all duration-200 min-h-[44px]",
    active
      ? "bg-soccer-primary/12 text-soccer-primary-800 font-semibold dark:bg-white/20 dark:text-white dark:shadow-md"
      : "text-muted-foreground hover:bg-muted hover:text-foreground dark:text-white/90 dark:hover:bg-white/10 dark:hover:text-white",
    className
  );
}

export const appNavGhostButtonClass =
  "text-muted-foreground hover:bg-muted hover:text-foreground dark:text-white/80 dark:hover:bg-white/5 dark:hover:text-white";

/** Profile/account control — slightly larger than bell/theme toggles; icon fills the circle. */
export const appNavProfileButtonClass =
  "h-10 w-10 shrink-0 rounded-full p-0 overflow-hidden text-foreground hover:bg-muted hover:text-foreground dark:text-white dark:hover:bg-white/10 transition-all duration-200";

export const groupSelectorTriggerClass =
  "h-8 gap-1 text-xs text-foreground bg-muted/70 hover:bg-muted hover:text-foreground border border-border/80 dark:text-white dark:bg-gray-800/50 dark:hover:bg-gray-700/50 dark:border-transparent";

export const appBottomNavActiveIndicatorClass =
  "absolute top-0 left-1/2 -translate-x-1/2 w-8 h-1 rounded-full bg-soccer-primary-700 dark:bg-white shadow-sm";
